export function filterRows(rows, searchTerm, getSearchText) {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return rows;
  return rows.filter((row) => getSearchText(row).toLowerCase().includes(term));
}

export function paginateRows(rows, page, pageSize) {
  const safePageSize = Math.max(1, pageSize);
  const totalPages = Math.max(1, Math.ceil(rows.length / safePageSize));
  const safePage = Math.min(Math.max(1, page), totalPages);
  const start = (safePage - 1) * safePageSize;
  return {
    pageRows: rows.slice(start, start + safePageSize),
    totalPages,
    page: safePage
  };
}
